import { SSRSafeSuspense } from '@zep/common/react-boundary';
import { useFunnel } from '@zep/react';
import { Cancel, CancelInformation } from '../../../../../components';
export const CancelPageView = () => {
  const [Funnel, setState] = useFunnel(['information', 'cancel'] as const);
  return <SSRSafeSuspense data-sentry-element="SSRSafeSuspense" data-sentry-component="CancelPageView" data-sentry-source-file="cancel.tsx">
      <Funnel data-sentry-element="Funnel" data-sentry-source-file="cancel.tsx">
        <Funnel.Step name="information" data-sentry-element="unknown" data-sentry-source-file="cancel.tsx">
          <CancelInformation onCancelClick={() => setState('cancel')} data-sentry-element="CancelInformation" data-sentry-source-file="cancel.tsx" />
        </Funnel.Step>
        <Funnel.Step name="cancel" data-sentry-element="unknown" data-sentry-source-file="cancel.tsx">
          <Cancel data-sentry-element="Cancel" data-sentry-source-file="cancel.tsx" />
        </Funnel.Step>
      </Funnel>
    </SSRSafeSuspense>;
};